module.exports = __webpack_public_path__ + "img/doorLogo2.323eb2bb.png";